import React from "react";
import { useTheme } from "styled-components";
import { scroller } from "react-scroll";

import { HOMEPAGE_V2 } from "@config/testIds/app";

import { ANCHOR_IDS } from "@typings/anchorIds";

import { Button } from "@components/General/Button";

import {
  CalendarScheduleTime,
  Heart,
  SingleUserHeartUser,
} from "@ui/Assets/MyIcons";

import { useTranslate } from "@hooks/useTranslate";

import * as Styled from "./Explanation.styled";

export const Explanation: React.FC<
  Pick<React.ComponentPropsWithoutRef<"div">, "className">
> = ({ className }) => {
  const translate = useTranslate("batmaid_pwa_static_homepage");
  const theme = useTheme();

  const clickHandler = () => {
    scroller.scrollTo(ANCHOR_IDS.BOOK_CLEANING, {
      smooth: true,
    });
  };

  return (
    <Styled.Root className={className}>
      <Styled.Title>{translate("how_it_works_heading")}</Styled.Title>

      <Styled.BookingSteps>
        <Styled.Step>
          <Styled.StepIcon>
            <CalendarScheduleTime width={theme.icons.sizes.base_x4} />
          </Styled.StepIcon>
          <Styled.StepDescription>
            {translate("how_it_works_step_1")}
          </Styled.StepDescription>
        </Styled.Step>

        <Styled.Step>
          <Styled.StepIcon>
            <SingleUserHeartUser width={theme.icons.sizes.base_x4} />
          </Styled.StepIcon>
          <Styled.StepDescription>
            {translate("how_it_works_step_2")}
          </Styled.StepDescription>
        </Styled.Step>

        <Styled.Step>
          <Styled.StepIcon $withoutLine>
            <Heart width={theme.icons.sizes.base_x4} />
          </Styled.StepIcon>
          <Styled.StepDescription>
            {translate("how_it_works_step_3")}
          </Styled.StepDescription>
        </Styled.Step>
      </Styled.BookingSteps>

      <Styled.CallToActionWrapper>
        <Button
          testId={HOMEPAGE_V2.BOOK_YOUR_CLEANING_BTN}
          type="button"
          variantStyle="fill"
          size="large"
          colorType="green"
          onClick={clickHandler}
        >
          {translate("how_it_works_button")}
        </Button>
      </Styled.CallToActionWrapper>
    </Styled.Root>
  );
};
